export default "__VITE_ASSET__tSEhwnUq__"